"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserDetailDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const Intention_dto_1 = require("./Intention.dto");
const UserRoleSummary_dto_1 = require("./UserRoleSummary.dto");
const Venue_dto_1 = require("./Venue.dto");
class UserDetailDto {
  constructor() {
    this.roles = [];
    this.visits = [];
  }
}
exports.UserDetailDto = UserDetailDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'App user profile public ID when the account has a linked User record'
}), __metadata("design:type", Object)], UserDetailDto.prototype, "userPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AccountKind
}), __metadata("design:type", String)], UserDetailDto.prototype, "kind", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => UserRoleSummary_dto_1.UserRoleSummaryDto,
  isArray: true
}), __metadata("design:type", Array)], UserDetailDto.prototype, "roles", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserDetailDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user shows their gender preferences on their profile.'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UserDetailDto.prototype, "isInternal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user can check in/out when not physically at the venue.'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "allowRemoteCheckIn", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.MyPlaceProximityAction,
  description: 'What happens when this user is near one of their My Places.'
}), __metadata("design:type", String)], UserDetailDto.prototype, "myPlaceProximityAction", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user photo passed Ivy photo verification.'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'An admin removed this user\'s photo (replaced by a placeholder); the app asks them to upload a new one.'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "isPhotoRejectedByAdmin", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserDetailDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDetailDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDetailDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "deviceType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user row has a non-empty OneSignal device token'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "hasDeviceToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the stored device token is a valid OneSignal subscription UUID'
}), __metadata("design:type", Boolean)], UserDetailDto.prototype, "hasValidOneSignalToken", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDetailDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDetailDto.prototype, "publishedAppVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], UserDetailDto.prototype, "currentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDetailDto.prototype, "currentVenueCheckedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDetailDto.prototype, "failedPingCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDetailDto.prototype, "failedAuthenticationCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserDetailDto.prototype, "lockedOutAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserDetailDto.prototype, "visits", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDetailDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserDetailDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserDetailDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserDetailDto.prototype, "lastLoginAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: () => Intention_dto_1.IntentionDto
}), __metadata("design:type", Object)], UserDetailDto.prototype, "currentIntention", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'When the user last set or changed their current intention'
}), __metadata("design:type", Object)], UserDetailDto.prototype, "intentionUpdatedAt", void 0);
//# sourceMappingURL=UserDetail.dto.js.map